import { chartThemeDark, palette } from '@repo/ui/theme';

export const CHART_HEIGHT = 500;

export const CHART_PADDING = {
  SMALL_RANGE: 0.2,
  MEDIUM_RANGE: 0.15,
  LARGE_RANGE: 0.08,
  TIME_AXIS: 0.02,
  MIN_VALUE: 0.1,
} as const;

export const CHART_MARGINS = {
  top: 15,
  right: 20,
  bottom: 50,
  left: 65,
} as const;

export const CHART_MARGINS_STACKED = {
  top: 10,
  right: 20,
  bottom: 30,
  left: 65,
} as const;

export const CHART_PRECISION = {
  HIGH: 3,
  MEDIUM: 2,
  LOW: 1,
} as const;

export const CHART_ANIMATION = {
  mass: 1,
  tension: 170,
  friction: 26,
  clamp: false,
} as const;

export const CHART_THEME = chartThemeDark;

export type MetricType = 'hr' | 'hrv' | 'rr';
export type EegMetricType = 'focus' | 'calmAlert';

export interface MetricConfig {
  id: string;
  label: string;
  color: string;
  unit: string;
}

export const METRIC_CONFIGS: Record<MetricType, MetricConfig> = {
  hr: {
    id: 'heartRate',
    label: 'Heart Rate',
    color: palette.red,
    unit: 'BPM (beats/min)',
  },
  hrv: {
    id: 'heartRateVariability',
    label: 'HRV',
    color: palette.yellow,
    unit: 'ms',
  },
  rr: {
    id: 'respiratoryRate',
    label: 'Respiratory Rate',
    color: palette.cyan,
    unit: 'BPM (breaths/min)',
  },
} as const;

export const EEG_METRIC_CONFIGS: Record<EegMetricType, MetricConfig> = {
  focus: {
    id: 'focusScore',
    label: 'Focus Score',
    color: palette.indigo,
    unit: '',
  },
  calmAlert: {
    id: 'calmAlert',
    label: 'Calm / Alert',
    color: palette.yellow,
    unit: '',
  },
} as const;
